var cpvars = require("./cpvars");

import jquery from 'jquery';
window.jQuery = window.$ = jquery;
import 'bootstrap-sass';
import 'eonasdan-bootstrap-datetimepicker-npm';
import 'jquery-sortable';
import 'jquery.scrollto';
import 'jquery-ujs';
import 'jquery.localscroll';
import 'jquery-hoverintent';
import autosize from 'autosize';
window.autosize = autosize;
import 'select2/dist/js/select2.full';
import sprintfjs from 'sprintfjs';
import moment from 'moment';
window.sprintf = sprintfjs;
window.moment = moment;

require("./library");

require("./base/autocomplete.coffee");

require("./base/cache.coffee");

require("./base/cocoon.coffee");

require("./base/confirm.coffee");

var datepicker_utils = require("./base/datepicker.coffee");

var editor_utils = require("./base/editor_utils.coffee");

require("./base/dialog.coffee");

require("./base/file_upload.coffee");

require("./base/forms.coffee");

require("./base/lazy.coffee");

require("./base/limit_height.coffee");

require("./base/loading.coffee");

require("./base/mobile.coffee");

require("./base/new_object.coffee");

require("./base/notifications.coffee");

require("./base/placeholder.coffee");

require("./base/related.coffee");

require("./base/rest_in_place.coffee");

require("./base/sortable.coffee");

require("./base/tabs.coffee");

require('tinymce/tinymce');

require('tinymce/themes/modern');

require('tinymce/plugins/lists/plugin');

require('tinymce/plugins/charmap/plugin');

require('tinymce/plugins/searchreplace/plugin');

require('tinymce/plugins/insertdatetime/plugin');

require('tinymce/plugins/contextmenu/plugin');

require('tinymce/plugins/paste/plugin');

require('tinymce/plugins/code/plugin');

require('tinymce/plugins/preview/plugin');

require('tinymce/plugins/image/plugin');

require('tinymce/plugins/link/plugin');

require('tinymce/plugins/autolink/plugin');

$.ajaxSetup({
  headers: {
    'X-CSRF-Token': $('meta[name=csrf-token]').attr('content')
  }
});
export default $.extend(cpvars, {
  autosize: window.autosize,
  sprintf: window.sprintf,
  moment: window.moment,
  datepicker: datepicker_utils,
  editor: editor_utils
});
export var editor = editor_utils;
export var datepicker = datepicker_utils;